export default __webpack_public_path__ + "static/media/22.33cef9eb.JPG";